import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

import { RedirectManagerService } from '@services/app/redirect-manager.service';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FwyFormFieldModule } from 'uix/form-field';

@Component({
  selector: 'flashy-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, ToastModule, FwyFormFieldModule, ReactiveFormsModule],
})
export class AppComponent implements OnInit {
  content = new FormControl('');

  constructor(private redirectManagerService: RedirectManagerService) {}

  ngOnInit(): void {
    this.redirectManagerService.collectEvents();
  }
}
